import { AnalyticsDataState } from '../state'
import { MbAnalyticsActions } from '../actions'
import { createReducer, on } from '@ngrx/store'
import { DataAnalyticsClickSource, DataAnalyticsEventLabel } from '../../../shared/mb-constants'

export const initialState: AnalyticsDataState = {
  cart: {
    mostRecentAddToCartSource: {
      id: DataAnalyticsClickSource.UNKNOWN,
      eventLabel: DataAnalyticsEventLabel.UNKNOWN
    }
  }
}

export const reducer = createReducer(
  initialState,
  on(MbAnalyticsActions.resetCart, (state) => ({
    ...state,
    cart: { ...initialState.cart }
  })),
  on(MbAnalyticsActions.addToCart, (state, { addToCartSource, eventLabel }) => ({
    ...state,
    cart: {
      ...state.cart,
      mostRecentAddToCartSource: {
        id: addToCartSource ?? DataAnalyticsClickSource.UNKNOWN,
        eventLabel: eventLabel ?? DataAnalyticsEventLabel.UNKNOWN
      }
    }
  }))
)
